import  "./title.css";

export default function Titulo({clase,title}) {
    return (
      <h3 className={clase}>{title}</h3>
    );
  }